import React from 'react';
import FadeIn from './animations/FadeIn';
import ContentRotator from './ContentRotator';
import defaultTestimonials from '../constants/testimonials';

const TestimonialBlock = ({ testimonials = defaultTestimonials }) => {
  return testimonials.length > 0 ? (
    <FadeIn>
      <ContentRotator interval={10}>
        {testimonials.map((testimonial, i) => (
          <div
            key={i}
            className="p-[25px] flex flex-col h-full w-full lg:p-[50px] lg:px-[65px] lg:mx-3  max-w-full bg-dusk-light lg:rounded-[8px] shadow"
          >
            <div className="text-sm mb-6">“{testimonial.quote}”</div>
            <div
              className="w-[82px] h-[82px] mb-3 mt-auto rounded-full bg-black mx-auto bg-cover bg-center lozad"
              data-background-image={testimonial.avatar}
            />
            <div className="text-sm !mb-0">
              {testimonial.name}
              <br />
              <span className="text-xs">{testimonial.business}</span>
            </div>
          </div>
        ))}
      </ContentRotator>
    </FadeIn>
  ) : null;
};

export default TestimonialBlock;
